import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Slider from 'react-slick';

import BannerChiquinhoMobile from '../../assets/img/cardapio-full/vs2026-01/chiquinho-cardapio-online-promo-01.jpg';

import './styles.css';

export default class Carousel extends Component {
  render() {
    const settings = {
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 10000,
      pauseOnHover: false,
      arrows: false,
    };

    return (
      <Slider {...settings}>
       
       <div>
          <img src={BannerChiquinhoMobile} alt="Chiquinho" />
        </div>

      </Slider>
    );
  }
}
